import { loadAndSetDetailContract } from '../../../commons/apiCalls';

const mapStateToProps = state => ({
  contractsList: state.tourOperation.contractsList,
  contractDetailList: state.tourOperation.contractDetailList,
  hotelCode: state.tourOperation.hotel,
  tourOperator: state.tourOperation.operator
});

const mapDispatchToProps = dispatch => ({
  loadFullContractData: (
    reservationId,
    hotelCode,
    tourOperator,
    contractData,
    markAsModification,
    errorCallBack
    ) => {
    dispatch(
      loadAndSetDetailContract(
        reservationId,
        hotelCode,
        tourOperator,
        contractData,
        markAsModification,
        errorCallBack
      )
    )
  },
  updateReservationContract: (reservationId, rateCode, contract, modified) => {
    dispatch({
      type: 'UPDATE_RESERVATION_CONTRACT',
      id: reservationId,
      rateCode,
      contract,
      modified
    })
  }
});

export { mapStateToProps, mapDispatchToProps };
